<template>
	<div class="SortableTable">
		<table class="st-table st-table--full">
            <thead>
                <tr>
                	<th
                	v-for="column in columns"
                	class="st-table__th"
                	:class="getCSSClasses(column)"
					@click="toggleSort(column)"
                	>{{ $t('Column: ' + column) }}
                		<span v-if="sort == column">
							<i v-if="direction == '+'" class="fa fa-angle-up"></i>
							<i v-else class="fa fa-angle-down"></i>
                		</span>
                	</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="users && users.length > 0" v-for="(user, index) in users" :class="{ 'has-action' : user.urls && Object.keys(user.urls).length > 0 }">
                	<td
                	v-for="column in columns"
					class="st-table__td"
                	:class="'st-table__td--' + column"
                	>
                		<DynamicColumn
                		v-if="column == 'this'"
                		:simple="false"
                		:reference="user"
                		:data="user"
                		:row="user"
                		></DynamicColumn>
                		<DynamicColumn
                		v-else-if="user[column]"
                		:simple="simpleusers"
                		:reference="user"
                		:data="user[column]"
                		:row="user"
                		></DynamicColumn>
						<div v-else>---</div>
                	</td>
                </tr>

                <tr v-if="!users || users.length <= 0">
					<td colspan="3">
						<div v-if="loading" class="text-center"><div class="spinner"></div></div>
						<div v-else>{{ $t('Nothing Found') }}</div>
					</td>
            	</tr>
            </tbody>
        </table>

		<router-link v-if="newlink" :to="newlink" class="st-btn st-btn--small st-btn--submit">New</router-link>
	</div>
</template>

<script>

import ListFilters from '@/components/ListFilters';
import DynamicColumn from '@/components/DynamicColumn';
import CUser from '@/components/c-user';

export default {
	name: 'SortableTable',
	components: {
		ListFilters,
		DynamicColumn,
		CUser
	},
	computed: {
		loading(){
			return this.$store.getters.loading;
		}
	},
	data: function () {
		return {
			sort: 'this',
			direction: '+'
		}
	},
	props: {
		role: {
			default: ''
		},
		users: {
			default(){
				return [];
			}
		},
		columns: {
			default(){
				return ['image', 'this', 'mainrole', 'subrole', 'leader'];
			}
		},
		sortable: {
			default(){
				return ['this', 'mainrole', 'subrole', 'leader', 'appointment', 'title'];
			}
		},
		simpleusers: {
			default: true
		},
		newlink: {
			default: false
		},
	},
	methods: {
		getCSSClasses(column){
			var css = {};
			console.log()
			css['st-table__th--' + column] = true;
			if(this.sortable.indexOf(column) >= 0) css['pointer'] = true;
			return css
		},
		filterUpdate(filter){
			console.log('filterUpdate',filter)
		},
		toggleSort(column){
			if(this.sortable.indexOf(column) < 0){
				return ;
			}
			if(this.sort != column){
				this.sort = column;
				this.direction = '+';
			} else {
				// togglelingen
				this.direction = this.direction == '+' ? '-' : '+';
			}
			this.$emit('update', {
				column: this.sort,
				direction: this.direction,
			})
		}
	}

}
</script>

<style scoped>
.SortableTable__th--image {
	width: 100px;
}
.SortableTable__th--role {
	width: 30%;
}
.pointer {
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SortableTable.vue